import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Navigation, Logo, Hamburger } from "./styled";
import { theme } from "../../theme";
import logo from "../../images/serce-finansow-logo.svg";
import hamburger from "../../images/hamburger.svg";
import MenuLinks from "./menuLinks";
import { Link } from "react-router-dom";

const Menu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleRef = useRef(null);
  const isMobile = useMediaQuery({ maxWidth: theme.breakpoint.tabletMax });

  useEffect(() => {
    if (!isMenuOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isMenuOpen]);

  const scrollToUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <Navigation>
      <Link to="/" onClick={() => { handleLinkClick(); scrollToUp(); }}>
        <Logo src={logo} alt="logo Serce Finansów" />
      </Link>

      {isMobile ? (
        <>
          <Hamburger
            ref={toggleRef}
            type="button"
            onClick={handleMenuToggle}
            aria-label={isMenuOpen ? "Zamknij menu" : "Otwórz menu"}
            aria-expanded={isMenuOpen}
            aria-controls="menu-glowne"
          >
            <img src={hamburger} alt="" />
          </Hamburger>
          {isMenuOpen && (
            <MenuLinks
              handleLinkClick={handleLinkClick}
              scrollToUp={scrollToUp}
            />
          )}
        </>
      ) : (
        <MenuLinks handleLinkClick={handleLinkClick} scrollToUp={scrollToUp} />
      )}
    </Navigation>
  );
};

export default Menu;

